import React, { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Menu, X, LogOut, UserCircle } from "lucide-react";
import Monogram from "./Monogram";
import { useAuth } from "../lib/auth";

const NAV = [
  { to: "/", label: "Inicio" },
  { to: "/predicas", label: "Prédicas" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <header
      className="sticky top-0 z-40 border-b border-[#ECE6D8] bg-[rgba(251,249,244,0.9)] backdrop-blur-xl"
      data-testid="site-header"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 flex items-center gap-4 py-3 md:py-4">
        <Link to="/" className="flex items-center gap-3 group" data-testid="header-logo-link">
          <Monogram />
          <div className="hidden sm:block leading-tight">
            <div className="font-display text-lg md:text-xl font-bold text-[#1B1C1A]">Pastor Osvaldo Paiva</div>
            <div className="text-sm text-[#55594F]">Pastor principal · Iglesia Casa de Oración · Ciudad del Este</div>
          </div>
        </Link>
        <nav className="ml-auto hidden md:flex items-center gap-1" data-testid="desktop-nav">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.to === "/"}
              className={({ isActive }) =>
                `px-5 py-2.5 rounded-full font-semibold text-[16px] transition ${
                  isActive
                    ? "text-[#1B1C1A] bg-[#F5EFE2]"
                    : "text-[#3F433C] hover:bg-[#F5EFE2]"
                }`
              }
              data-testid={`nav-${n.to === "/" ? "home" : n.to.replace("/", "")}`}
            >
              {n.label}
            </NavLink>
          ))}
          {user?.is_admin ? (
            <>
              <NavLink to="/estudio" className="px-5 py-2.5 rounded-full font-semibold text-[16px] text-[#3F433C] hover:bg-[#F5EFE2]" data-testid="nav-estudio">
                Estudio
              </NavLink>
              <button onClick={() => { logout(); navigate("/"); }} className="pill pill-xs pill-outline ml-2" data-testid="btn-logout">
                <LogOut size={16} /> Salir
              </button>
            </>
          ) : (
            <Link to="/estudio/login" className="pill pill-xs pill-outline ml-2" data-testid="nav-login">
              <UserCircle size={18} /> Estudio del pastor
            </Link>
          )}
        </nav>
        <button
          className="ml-auto md:hidden p-3 rounded-xl border border-[#ECE6D8] bg-white"
          onClick={() => setOpen((o) => !o)}
          aria-label="Menú"
          data-testid="btn-mobile-menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>
      {open && (
        <div className="md:hidden px-4 pb-4 flex flex-col gap-2 border-t border-[#ECE6D8]" data-testid="mobile-nav">
          {NAV.map((n) => (
            <Link
              key={n.to}
              to={n.to}
              onClick={() => setOpen(false)}
              className="px-5 py-4 rounded-2xl bg-white border border-[#ECE6D8] text-[#1B1C1A] font-semibold text-base"
              data-testid={`mnav-${n.label}`}
            >
              {n.label}
            </Link>
          ))}
          {user?.is_admin ? (
            <>
              <Link to="/estudio" onClick={() => setOpen(false)} className="px-5 py-4 rounded-2xl bg-white border border-[#ECE6D8] text-[#1B1C1A] font-semibold">Estudio</Link>
              <button onClick={() => { logout(); setOpen(false); navigate("/"); }} className="pill pill-sm pill-outline">Salir</button>
            </>
          ) : (
            <Link to="/estudio/login" onClick={() => setOpen(false)} className="pill pill-sm pill-outline" data-testid="mnav-login">Estudio del pastor</Link>
          )}
        </div>
      )}
    </header>
  );
}
